import * as React from "react";

const IconLinkCaretDown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="currentColor"><polygon fill="currentColor" points="4.28 4.809 4.545 4.545 8.295 .795 8.559 .53 8.03 0 7.765 .265 4.28 3.75 .795 .265 .53 0 0 .53 .265 .795 4.015 4.545"  transform="translate(.97 .47)"/></svg>;
};

export default React.memo(IconLinkCaretDown);
